module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/band-and-orchestra-6b6eecde1688185630d81e4365bdf926.png";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/band-and-orchestra.png
// module id = 1+jO
// module chunks = 9 12